import React from 'react';
import _ from 'lodash';
import {SVGICONS} from '@ey/icons';
import styled from 'styled-components';
import {
	rbacRoleKeys,
	UserERPTypeId,
	currentResource,
	labels
} from '../../../util/uiconstants';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import MotifBadge from '@ey/motif-react-wrapper/Badge';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';

const PermissionList = ({rbacRoles, picFlag, userType}) => {
	let isAdminRole = false,
		isDefaultRole = false,
		rolesExceptAdminandDefault = [],
		isReadOnly = false;
	let internalUserRoles = currentResource.internalUserRoles;

	if (Array.isArray(rbacRoles)) {
		_.map(rbacRoles, (rbacRole) => {
			if (rbacRole.roleKey === rbacRoleKeys.adminRole) {
				isAdminRole = true;
			} else if (rbacRole.roleKey === rbacRoleKeys.defaultRole) {
				isDefaultRole = true;
			} else if (rbacRole.roleKey === rbacRoleKeys.ThirdPartyUserReadOnly) {
				isReadOnly = true;
			} else {
				let matchedRole = _.find(internalUserRoles, {
					roleKey: rbacRole.roleKey
				});

				if (matchedRole) {
					rolesExceptAdminandDefault.push(matchedRole);
				}
			}
		});
	}

	let mergedLocalizedList = _.map(internalUserRoles, function (localizedRole) {
		return _.find(rolesExceptAdminandDefault, function (r) {
			return r.roleKey === localizedRole.roleKey;
		});
	});

	let newList = _.compact(mergedLocalizedList);

	if (
		newList.some(
			(x) => x.roleKey == rbacRoleKeys.StrictlyConfidentialDocumentsRole
		)
	) {
		newList = newList.filter(
			(r) =>
				r.roleKey != rbacRoleKeys.HighConfidentialDocumentsRole &&
				r.roleKey != rbacRoleKeys.ModerateConfidentialDocumentsRole &&
				r.roleKey != rbacRoleKeys.LowConfidentialDocumentsRole
		);
	} else if (
		newList.some((x) => x.roleKey == rbacRoleKeys.HighConfidentialDocumentsRole)
	) {
		newList = newList.filter(
			(r) =>
				r.roleKey != rbacRoleKeys.ModerateConfidentialDocumentsRole &&
				r.roleKey != rbacRoleKeys.LowConfidentialDocumentsRole
		);
	} else if (
		newList.some(
			(x) => x.roleKey == rbacRoleKeys.ModerateConfidentialDocumentsRole
		)
	) {
		newList = newList.filter(
			(r) => r.roleKey != rbacRoleKeys.LowConfidentialDocumentsRole
		);
	}

	//Sorting for group and role
	let sortedList = _.orderBy(
		newList,
		['groupDisplayOrder', 'roleDisplayOrder'],
		['asc', 'asc']
	);

	let allGroups = sortedList.map((r) => {
		return {groupName: r.groupName, sectionId: r.sectionId};
	});

	let uniqueGroups = _.uniqWith(allGroups, _.isEqual);

	const permissionLabel =
		sortedList.length === 1 ? labels.permissionLabel : labels.permission;

	return (
		<>
			{isAdminRole && (
				<div className="motif-badge motif-badge-alt">
					<span className="motif-badge-number"> {labels.adminRole}</span>{' '}
				</div>
			)}
			{picFlag && (
				<div className="pic">
					<span className="picflag"> {labels.picRole}</span>{' '}
				</div>
			)}
			{isReadOnly && (
				<div className="motif-badge read-only">
					<span className="motif-badge-number">
						{' '}
						{labels.readOnlyRoleForThirdPartyUser}
					</span>{' '}
				</div>
			)}
			{sortedList && sortedList.length > 0 ? (
				<MotifDropdown
				ariaLabelledby="permission-list-dropdown"
				placement='auto'
				trigger={
					<MotifBadge className='permission-badge'
						value={`${sortedList.length} ${permissionLabel}`}
						variant="default"
					/>
				}
			>
				<StyledDisplayRoles className="customScrollbar">
					{uniqueGroups.map((grp) => {
						return (
							<section className="motif-dropdown-group">
								<h3 className="motif-body2-default-bold motif-dropdown-group-title">
									{grp.groupName}
								</h3>
									{sortedList
										.filter((role) => role.sectionId == grp.sectionId)
										.map((role) => {
											return (
													<MotifDropdownItem className="motif-body2-default-light permissionlist">
														<EllipsesControl
															content={role.displayName}
															tooltip={role.displayName}
															noOfLines={1}
														/>
													</MotifDropdownItem>
											);
										})}
							</section>
						);
					})}
				</StyledDisplayRoles>
			</MotifDropdown>
			) : !isDefaultRole && userType !== UserERPTypeId.ThirdPartyUser ? (
				<div className="motif-badge motif-badge-alt">
					<span className="motif-badge-number"> {labels.legacy}</span>{' '}
				</div>
			) : null}
		</>
	);
};

export default PermissionList;

const StyledDisplayRoles = styled.ul`
	width: var(--px-200);
	max-height: var(--px-210);
	overflow-y: auto;

	.permissionlist {
		width: 90%;
	}
`;
